import MarketSiteRegions from './MarketSiteRegions.js';
import SitesLocalStorageService from './sitesLocalStorageService.js';
import storage from './storage.js';
import GeoIPService from './geoipService.js'

/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace GeoIPMarketRedirect
 */
export default class GeoIPMarketRedirect {
    constructor(_geoIPData) {
        this.COUNTRY_COOKIE_KEY = "countryCode";
        this.REGION_COOKIE_KEY = "regionCode";
        this.DEFAULT_REDIRECT_PAGE = "/home.html";
        this.geoipData = _geoIPData;
        this.countryCookie = SitesLocalStorageService.getItem(this.COUNTRY_COOKIE_KEY);
        this.regionCode = SitesLocalStorageService.getItem(this.REGION_COOKIE_KEY);
        this.languageCookie = this.getLanguage();
    }

    getLanguage() {
        let locale = navigator.language;
        let locationArray = locale.split('-');
        let language = "";
        if(locationArray.length > 0){
            return locationArray[0];
        }
        return "";
    }

    getMarketSiteRedirect() {
        let deferred = $.Deferred();
        if (this.countryCookie && this.languageCookie && this.regionCode) {
            this.proccessMarketSiteRedirect(this.languageCookie, this.countryCookie, this.regionCode, deferred);
        } else {
            if (this.geoipData) {
                this.onMarketSuccess(this.geoipData, deferred);
            } else {
                GeoIPService.getAllCountry((geoipResponse) => {
                    this.geoipData = geoipResponse;
                    this.onMarketSuccess(geoipResponse, deferred);
                }, (geoipResponse) => {
                    this.onMarketError(geoipResponse, deferred);
                });
            }
        }

        return deferred.promise();
    }

    //PRIVATE FUNCTIONS

    onMarketSuccess(geoipResponse, deferred) {
        const trustArc = JSON.parse(localStorage.getItem('truste.eu.cookie.notice_gdpr_prefs'));
        const EU = 'europe';
        let country = geoipResponse.country.iso_code;
        const regionCode = MarketSiteRegions.getMarketSiteRegionByCountry(country);
        let locale = navigator.language;
        let locationArray = locale.split('-');
        let language = "";
        if(locationArray.length > 0){
            language = locationArray[0];
        }
        if (regionCode !== EU || (regionCode === EU && trustArc && storage.isAllowed('Functional'))) {
            this.saveCookieData(country, regionCode);
        }
        this.proccessMarketSiteRedirect(language, country, regionCode, deferred);
    }

    onMarketError(geoipError, deferred) {
        console.error("geoIP lookup error ", geoipError);
        deferred.reject(geoipError);
    }

    proccessMarketSiteRedirect(language, country, regionCode, deferred) {
        let marketName;
        let marketUrl;
        MarketSiteRegions.getMarketSiteRegionData(true).then(data => {
            let count = 0;
            let regionLength = data.length;
            data.map(region => {
                if (region.hasOwnProperty("countryname")) {
                    region.countryname.map(market => {
                        if (market.hasOwnProperty("countryCode") && country === market.countryCode) {
                            if (market.hasOwnProperty("locale_names")) {
                                //Grab translated country
                                market.locale_names.map(locale_name => {
                                    if (locale_name.hasOwnProperty(language)) {
                                        marketName = locale_name[language];
                                    }
                                });
                                // If translated country wasn't found grab first one in list
                                if (!marketName) {
                                    for (let i = 0; i < market.locale_names.length; i++) {
                                        let locale_name = market.locale_names[i];
                                        for (let key in locale_name) {
                                            if (locale_name.hasOwnProperty(key)) {
                                                marketName = locale_name[key];
                                                break;
                                            }
                                        }
                                    }
                                    //If none in list default to United States
                                    if (!marketName) {
                                        marketName = "United States";
                                    }
                                }
                            } else {
                                deferred.reject();
                            }

                            if (market.hasOwnProperty("paths")) {
                                market.paths.map(localePaths => {
                                    if (localePaths.hasOwnProperty(language)) {
                                        if (localePaths[language].indexOf("http") !== -1) {
                                            marketUrl = localePaths[language];
                                        } else {
                                            marketUrl = localePaths[language] + this.DEFAULT_REDIRECT_PAGE;
                                        }
                                    }
                                });
                                if (!marketUrl) {
                                    for (let key in market.paths[0]) {
                                        if (market.paths[0].hasOwnProperty(key)) {
                                            if (market.paths[0][key].indexOf("http") !== -1) {
                                                marketUrl = market.paths[0][key];
                                                break;
                                            } else {
                                                marketUrl = market.paths[0][key] + this.DEFAULT_REDIRECT_PAGE;
                                                break;
                                            }
                                        }
                                    }

                                    if (!marketUrl) {
                                        marketUrl = "/content/nuskin/en_US" + this.DEFAULT_REDIRECT_PAGE;
                                    }
                                }
                            } else {
                                deferred.reject();
                            }

                            deferred.resolve({
                                regionName: regionCode,
                                marketName: marketName,
                                marketUrl: marketUrl,
                                languageCode: language,
                                countryCode: country,
                                regions: data
                            });
                        }


                    });
                }
                count++;
            });

            if (count === regionLength && !marketName && !marketUrl) {
                deferred.reject();
                deferred.reject({
                    countryCode: country,
                    languageCode: language,
                    isEU: isEU,
                    regions: data
                });
            }
        });
    }

    saveCookieData(country, region) {
        SitesLocalStorageService.writeItem(this.COUNTRY_COOKIE_KEY, country);
        SitesLocalStorageService.writeItem(this.REGION_COOKIE_KEY, region);
    }

    redirectMecommerceSite() {
        this.regionValue = "";
        this.languageValue = "";
        this.firebaseDatabaseURL = "";
        this.languageSelectionPage = $('#languageSelectionPageId').val();
        this.getEnvConfig();
    }

    getEnvConfig() {
        // Fire Base configs are independent of Locale hence writing URL of MeConfiguration directly
        $.ajax({
            url: '/content/configuration/global/mec.service.US.json',
            method: 'GET',
            dataType: 'json',
            async: false,
            success: function (response) {
                this.firebaseDatabaseURL = response.system['firebaseDatabaseURL'];
                if (this.geoipData) {
                    this.onMecommerceSuccess(this.geoipData);
                }else {
                    this.onMecommerceError(this.geoipData);
                };
            },
            error: function(xhr) {
                console.error("Mecommerce Config Exception: ", xhr);
            }
        });
    }

    onMecommerceSuccess(geoipResponse){
        let locale = navigator.language;
        let locationArray = locale.split('-');
        let language = "";
        let countryCode = "US";
        if(locationArray.length > 0){
            language = locationArray[0];
        }
        if(this.countryCookie && this.languageCookie){
            this.getLocationJson(this.countryCookie, this.languageCookie, function(){
                if(this.languageValue == '' || this.regionValue == ''){
                    $(location).attr('href', this.languageSelectionPage+'.html');
                } else {
                    this.redirectMecommerceBrowser(this.languageValue, this.countryCookie, this.regionValue);
                }
                return;
            });

        } else if(this.countryCookie && this.languageCookie == undefined){
            this.getLocationJson(countryCookie, language, function(){
                if(this.languageValue == '' || this.regionValue == ''){
                    $(location).attr('href', this.languageSelectionPage+'.html');
                } else {
                    this.redirectMecommerceBrowser(this.languageValue, this.countryCookie, this.regionValue);
                }
                return;
            });

        } else if(this.countryCookie == undefined && this.languageCookie){
            var code = "";
            if(!geoipResponse.country){
                code = countryCode;
                this.getLocationJson(code, this.languageCookie, function(){
                    if(this.languageValue == '' || this.regionValue == ''){
                        $(location).attr('href', this.languageSelectionPage+'.html');
                    } else {
                        this.redirectMecommerceBrowser(this.languageValue, code, this.regionValue);
                    }
                    return;
                });
            } else {
                code = geoipResponse.country.iso_code;
                this.getLocationJson(code, languageCookie, function(){
                    if(this.languageValue == '' || this.regionValue == ''){
                        $(location).attr('href', this.languageSelectionPage+'.html');
                    } else {
                        this.redirectMecommerceBrowser(this.languageValue, code, this.regionValue);
                    }
                    return;
                });
            }

        } else if(this.countryCookie == undefined && this.languageCookie == undefined){
            var code = "";
            if(!geoipResponse.country){
                code = countryCode;
                this.getLocationJson(code, language, function(){
                    if(this.languageValue == '' || this.regionValue == ''){
                        $(location).attr('href', this.languageSelectionPage+'.html');
                    } else {
                        this.redirectMecommerceBrowser(this.languageValue, code, this.regionValue);
                    }
                    return;
                });
            } else {
                code = geoipResponse.country.iso_code;
                this.getLocationJson(code, language, function(){
                    if(this.languageValue == '' || this.regionValue == ''){
                        $(location).attr('href', this.languageSelectionPage+'.html');
                    } else {
                        this.redirectMecommerceBrowser(this.languageValue, code, this.regionValue);
                    }
                    return;
                });
            }

        }
    }

    onMecommerceError(error){
        let locale = navigator.language;
        let locationArray = locale.split('-');
        let language = "";
        let countryCode = "US";
        if(locationArray.length > 0){
            language = locationArray[0];
        }
        this.getLocationJson(countryCode, language, function(){
            if(this.languageValue == '' || this.regionValue == ''){
                $(location).attr('href', this.languageSelectionPage+'.html');
            } else {
                this.redirectMecommerceBrowser(this.languageValue, countryCode, this.regionValue);
            }
            return;
        });
    }

    getLocationJson(country, browserLanguage, callback){
        let locationUrl = location.pathname;
        let siteName = locationUrl.split("/")[2];
        $.ajax({
            url: "/mecommerce/core/regions."+siteName+".json",
            dataType: "json",
            success: function(data){
                this.getMecommerceRegionsData(data, country, browserLanguage);
                callback();
            },
            error: function(data){
                $(location).attr('href', this.languageSelectionPage+'.html');
            }
        });
    }

    getMecommerceRegionsData(data, country, browserLanguage){
        if(data){
            let regionArray = data.regions;
            if(regionArray){
                for(let i = 0; i < regionArray.length; i++){
                    let eachRegion = regionArray[i];
                    // eachRegion looks like this:
                    // { "americas" : [ {...}, {...} ] }
                    // So, the eachRegionkey (e.g., "americas" is just the first element
                    let eachRegionKey = Object.keys(eachRegion)[0];
                    for(let j = 0; j < eachRegion[eachRegionKey].length; j++){
                        let eachCountry = eachRegion[eachRegionKey][j];
                        // countryKey is similar to eachRegionKey, need to get the first element
                        let countryKey = Object.keys(eachCountry)[0];
                        if(countryKey == country){
                            let countryLanguages = eachCountry[countryKey].languages;
                            for (let key in countryLanguages) {
                                if(key == browserLanguage){
                                    this.languageValue = key;
                                    this.regionValue = eachRegionKey;
                                    return;
                                }
                                this.regionValue = eachRegionKey;
                            }
                            if(!this.languageValue){
                                this.languageValue = Object.keys(countryLanguages)[0];
                            }
                        }
                    }
                }
            }
        }

    }

    redirectMecommerceBrowser(languageCode, countryCode, regionCode){
        let url = location.href;
        let modified_uri = getLocation(url);
        let storeFrontName = getParamValue(url, "storeFront");
        let storeFrontHomePage = $('#storeFrontHomePageId').val();
        let homePage = $('#homePageNameId').val();

        if(storeFrontName){
            $.ajax({
                url: firebaseDatabaseURL+"/storefront/subdomains/"+storeFrontName+".json",
                success: function(response){
                    if(response){
                        let storeFrontId = response;
                        $.cookie("countryCode", countryCode, {path: '/', domain: '.mynuskin.com'});
                        $.cookie("languageCode", languageCode, {path: '/', domain: '.mynuskin.com'});
                        $(location).attr('href', '/content/mecommerce/'+regionCode+'/'+countryCode+'/'+languageCode+'/'+storeFrontHomePage+'.html?storeId='+storeFrontId);
                    } else {
                        $(location).attr('href', '/content/mecommerce/'+regionCode+'/'+countryCode+'/'+languageCode+'/'+homePage+'.html');
                    }

                }
            });
        } else {
            let hostName = modified_uri.hostname;
            let urlparts = hostName.split(".");
            if(urlparts.length > '3' && ((urlparts[1] == 'test' || urlparts[0] == 'test') || (urlparts[1] == 'dev' || urlparts[0] == 'dev'))){
                storeFrontName = urlparts[0];
                $.ajax({
                    url: firebaseDatabaseURL+"/storefront/subdomains/"+storeFrontName+".json",
                    success: function(response){
                        if(response){
                            let storeFrontId = response;
                            let updatedHostname = "";
                            $.cookie("countryCode", countryCode, {path: '/', domain: '.mynuskin.com'});
                            $.cookie("languageCode", languageCode, {path: '/', domain: '.mynuskin.com'});
                            $(location).attr('href', '/content/mecommerce/'+regionCode+'/'+countryCode+'/'+languageCode+'/'+storeFrontHomePage+'.html?storeId='+storeFrontId);
                        } else {
                            $(location).attr('href', '/content/mecommerce/'+regionCode+'/'+countryCode+'/'+languageCode+'/'+homePage+'.html');
                        }
                    }
                });
            } else if(urlparts.length == '3'){
                let updatedHostname = "";
                if(urlparts[0] !== 'www' && urlparts[0] !== 'test' && urlparts[0] !== 'dev'){
                    storeFrontName = urlparts[0];
                    $.ajax({
                        url: firebaseDatabaseURL+"/storefront/subdomains/"+storeFrontName+".json",
                        success: function(response){
                            if(response){
                                $.cookie("countryCode", countryCode, {path: '/', domain: '.mynuskin.com'});
                                $.cookie("languageCode", languageCode, {path: '/', domain: '.mynuskin.com'});
                                let storeFrontId = response;
                                $(location).attr('href', '/content/mecommerce/'+regionCode+'/'+countryCode+'/'+languageCode+'/'+storeFrontHomePage+'.html?storeId='+storeFrontId);
                            } else {
                                $(location).attr('href', '/content/mecommerce/'+regionCode+'/'+countryCode+'/'+languageCode+'/'+homePage+'.html');
                            }
                        }
                    });
                } else {
                    $.cookie("countryCode", countryCode, {path: '/', domain: '.mynuskin.com'});
                    $.cookie("languageCode", languageCode, {path: '/', domain: '.mynuskin.com'});
                    $(location).attr('href', '/content/mecommerce/'+regionCode+'/'+countryCode+'/'+languageCode+'/'+homePage+'.html');
                }
            }
        }
    }

}
